import { message } from "antd";

const mntSavedCardsString = 'expo_mnt_saved_cards';

export const saveCards = (cards) => {
  if (!window.localStorage) {
    return;
  }

  window.localStorage.setItem(mntSavedCardsString, JSON.stringify(cards));
  message.success({
    content: 'Cards have been saved locally. You can continue off from this location when you return.',
    style: {
      marginTop: '20px',
    },
  });
};

export const getCardsFromStorage = () => {
  if (!window.localStorage) {
    return;
  }

  const savedCards = window.localStorage.getItem(mntSavedCardsString);

  return savedCards ? JSON.parse(savedCards) : [];
}

export const clearCards = () => {
  if (!window.localStorage) {
    return;
  }

  window.localStorage.removeItem(mntSavedCardsString);
};

export const getAjaxUrl = () => {
  return window.woocommerce_params ? window.woocommerce_params.ajax_url : '/wp-admin/admin-ajax.php';
}